import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/_ui/Dialog'
import T from '@/components/Helpers/Translate'
import { useGetSubscriptions } from '@/lib/hooks/services/useGetSubscriptions'
import useGlobalStore from '@/store/useGlobalStore'
import React, { useEffect } from 'react'
import type { CartItemType } from '@/store/types/cart'
import Image from 'next/image'
import type { HydraGetSkuAvailabilityResponse } from '@/lib/services/Hydra/order/getSkuAvailability'
import {
  TrackSubscriptionModalAppears,
  TrackSubscriptionSelected,
} from '@/lib/services/mixpanel/events/subscriptionEvents'
import { SelectActiveSubscriptionList } from './SelectActiveSubscriptionList'

type Props = {
  itemToAddToSubscription: CartItemType
  isLoadingProductAvailability: boolean
  productAvailability: HydraGetSkuAvailabilityResponse | null
}

export const SelectActiveSubscription = ({
  itemToAddToSubscription,
  isLoadingProductAvailability,
  productAvailability,
}: Props) => {
  const {
    app: { addProductToSubscription },
    setAppAddProductToSubscription,
  } = useGlobalStore()

  useGetSubscriptions()

  useEffect(() => {
    TrackSubscriptionModalAppears().catch(() => {})
  }, [])

  return (
    <Dialog
      onOpenChange={(open) => {
        setAppAddProductToSubscription({
          isSelectActiveSubscriptionModalOpen: open,
        })
        if (!open) {
          TrackSubscriptionSelected({ scenario: 'dismiss' }).catch(() => {})
        }
      }}
      open={addProductToSubscription.isSelectActiveSubscriptionModalOpen}
    >
      {/* zIndex required for modal to show above quick add modal */}
      <DialogContent zIndex={3000} className="w-full max-w-2xl">
        <DialogHeader>
          <Image
            alt="Shipping box"
            src="/icons/box.svg"
            className="my-5"
            height={50}
            width={50}
          />
          <DialogTitle className="text-left">
            <T>combine_shipping_and_help_the_environment</T>
          </DialogTitle>
          <DialogDescription className="text-left">
            <T>combine_shipping_and_help_the_environment_description</T>
          </DialogDescription>
        </DialogHeader>
        <SelectActiveSubscriptionList
          isLoadingProductAvailability={isLoadingProductAvailability}
          productAvailability={productAvailability}
          itemToAddToSubscription={itemToAddToSubscription}
        />
      </DialogContent>
    </Dialog>
  )
}
